import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GearView } from '../../Model/GearView';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';
import { viewsKeys } from './queryKeyFactory';

export function useGetView(viewId?: number, locale?: string): UseQueryResult<GearView, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDefaultView = () => {
    if (servicesCtx?.viewsService && viewId != null) {
      return servicesCtx.viewsService.getView(viewId, locale);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: viewsKeys.singleViewForLocale(viewId, locale),
    queryFn: getDefaultView,
    retry: 0,
    enabled: viewId != null,
    staleTime: 1800000,
    gcTime: 1800000
  });
}
